/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BadRequestResponse,
  Folder,
  ForbiddenResponse,
  GetProjectIndexedPages200,
  InternalServerErrorResponse,
  NotFoundResponse,
  ReindexProject200,
  ReindexProjectSearch200,
  SearchProjectPages200,
  SearchProjectPagesBody,
  SearchProjectPagesParams,
  SetAsDefaultCase202,
  SetAsDefaultCaseBody,
  UnauthorizedResponse,
  UpdateProjectBody
} from '../model';

import { customInstance } from '../../custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Get a project
 */
export const getProject = (
    organizationId: string,
    projectId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Folder>(
      {url: `/organizations/${organizationId}/projects/${projectId}`, method: 'GET', signal
    },
      options);
    }




export const getGetProjectQueryKey = (organizationId: string,
    projectId: string,) => {
    return [
    `/organizations/${organizationId}/projects/${projectId}`
    ] as const;
    }


export const getGetProjectQueryOptions = <TData = Awaited<ReturnType<typeof getProject>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectQueryKey(organizationId,projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProject>>> = ({ signal }) => getProject(organizationId,projectId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined && projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectQueryResult = NonNullable<Awaited<ReturnType<typeof getProject>>>
export type GetProjectQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse


export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProject>>,
          TError,
          Awaited<ReturnType<typeof getProject>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProject>>,
          TError,
          Awaited<ReturnType<typeof getProject>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a project
 */

export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectQueryOptions(organizationId,projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Update a project
 */
export const updateProject = (
    organizationId: string,
    projectId: string,
    updateProjectBody: UpdateProjectBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<Folder>(
      {url: `/organizations/${organizationId}/projects/${projectId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateProjectBody, signal
    },
      options);
    }




export const getUpdateProjectMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,{organizationId: string;projectId: string;data: UpdateProjectBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,{organizationId: string;projectId: string;data: UpdateProjectBody}, TContext> => {

const mutationKey = ['updateProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProject>>, {organizationId: string;projectId: string;data: UpdateProjectBody}> = (props) => {
          const {organizationId,projectId,data} = props ?? {};

          return  updateProject(organizationId,projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof updateProject>>>
    export type UpdateProjectMutationBody = UpdateProjectBody
    export type UpdateProjectMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Update a project
 */
export const useUpdateProject = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,{organizationId: string;projectId: string;data: UpdateProjectBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProject>>,
        TError,
        {organizationId: string;projectId: string;data: UpdateProjectBody},
        TContext
      > => {
      return useMutation(getUpdateProjectMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete a project
 */
export const deleteProject = (
    organizationId: string,
    projectId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/organizations/${organizationId}/projects/${projectId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteProjectMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,{organizationId: string;projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,{organizationId: string;projectId: string}, TContext> => {

const mutationKey = ['deleteProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProject>>, {organizationId: string;projectId: string}> = (props) => {
          const {organizationId,projectId} = props ?? {};

          return  deleteProject(organizationId,projectId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProject>>>

    export type DeleteProjectMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Delete a project
 */
export const useDeleteProject = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,{organizationId: string;projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProject>>,
        TError,
        {organizationId: string;projectId: string},
        TContext
      > => {
      return useMutation(getDeleteProjectMutationOptions(options), queryClient);
    }
    /**
 * Starts a background job that copies the case to the static assets bucket under default-cases/{case}/{industry}/{version}/. The destination path is chosen using default-cases/config.json read at request time (next version suffix). After a successful copy, the background job re-reads config.json and appends the new version entry (with description, createdAt, deprecated: false) without changing currentVersion, then writes the updated config back to S3. The response is immediate (202) and includes a durable jobId that can be polled through the case-transfer job status endpoint. This route is registered only when the API deployment sets ENV to dev.
 * @summary Export project as next default-case seed (async)
 */
export const setAsDefaultCase = (
    organizationId: string,
    projectId: string,
    setAsDefaultCaseBody: SetAsDefaultCaseBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SetAsDefaultCase202>(
      {url: `/organizations/${organizationId}/projects/${projectId}/set-as-default`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setAsDefaultCaseBody, signal
    },
      options);
    }




export const getSetAsDefaultCaseMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAsDefaultCase>>, TError,{organizationId: string;projectId: string;data: SetAsDefaultCaseBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setAsDefaultCase>>, TError,{organizationId: string;projectId: string;data: SetAsDefaultCaseBody}, TContext> => {

const mutationKey = ['setAsDefaultCase'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAsDefaultCase>>, {organizationId: string;projectId: string;data: SetAsDefaultCaseBody}> = (props) => {
          const {organizationId,projectId,data} = props ?? {};

          return  setAsDefaultCase(organizationId,projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAsDefaultCaseMutationResult = NonNullable<Awaited<ReturnType<typeof setAsDefaultCase>>>
    export type SetAsDefaultCaseMutationBody = SetAsDefaultCaseBody
    export type SetAsDefaultCaseMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Export project as next default-case seed (async)
 */
export const useSetAsDefaultCase = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAsDefaultCase>>, TError,{organizationId: string;projectId: string;data: SetAsDefaultCaseBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setAsDefaultCase>>,
        TError,
        {organizationId: string;projectId: string;data: SetAsDefaultCaseBody},
        TContext
      > => {
      return useMutation(getSetAsDefaultCaseMutationOptions(options), queryClient);
    }
    /**
 * @summary Archive a project
 */
export const archiveProject = (
    organizationId: string,
    projectId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/organizations/${organizationId}/projects/${projectId}/archive`, method: 'POST', signal
    },
      options);
    }




export const getArchiveProjectMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveProject>>, TError,{organizationId: string;projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveProject>>, TError,{organizationId: string;projectId: string}, TContext> => {

const mutationKey = ['archiveProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveProject>>, {organizationId: string;projectId: string}> = (props) => {
          const {organizationId,projectId} = props ?? {};

          return  archiveProject(organizationId,projectId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveProjectMutationResult = NonNullable<Awaited<ReturnType<typeof archiveProject>>>

    export type ArchiveProjectMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Archive a project
 */
export const useArchiveProject = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveProject>>, TError,{organizationId: string;projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveProject>>,
        TError,
        {organizationId: string;projectId: string},
        TContext
      > => {
      return useMutation(getArchiveProjectMutationOptions(options), queryClient);
    }
    /**
 * @summary Restore an archived project
 */
export const restoreProject = (
    organizationId: string,
    projectId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/organizations/${organizationId}/projects/${projectId}/restore`, method: 'POST', signal
    },
      options);
    }




export const getRestoreProjectMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreProject>>, TError,{organizationId: string;projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof restoreProject>>, TError,{organizationId: string;projectId: string}, TContext> => {

const mutationKey = ['restoreProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreProject>>, {organizationId: string;projectId: string}> = (props) => {
          const {organizationId,projectId} = props ?? {};

          return  restoreProject(organizationId,projectId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestoreProjectMutationResult = NonNullable<Awaited<ReturnType<typeof restoreProject>>>

    export type RestoreProjectMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Restore an archived project
 */
export const useRestoreProject = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreProject>>, TError,{organizationId: string;projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof restoreProject>>,
        TError,
        {organizationId: string;projectId: string},
        TContext
      > => {
      return useMutation(getRestoreProjectMutationOptions(options), queryClient);
    }
    /**
 * Performs keyword search within a project's pages using OpenSearch. Returns matching pages with highlighted snippets.
 * @summary Search within a project's pages using keyword search
 */
export const searchProjectPages = (
    organizationId: string,
    projectId: string,
    searchProjectPagesBody: SearchProjectPagesBody,
    params?: SearchProjectPagesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<SearchProjectPages200>(
      {url: `/organizations/${organizationId}/projects/${projectId}/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchProjectPagesBody,
        params, signal
    },
      options);
    }




export const getSearchProjectPagesMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchProjectPages>>, TError,{organizationId: string;projectId: string;data: SearchProjectPagesBody;params?: SearchProjectPagesParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof searchProjectPages>>, TError,{organizationId: string;projectId: string;data: SearchProjectPagesBody;params?: SearchProjectPagesParams}, TContext> => {

const mutationKey = ['searchProjectPages'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof searchProjectPages>>, {organizationId: string;projectId: string;data: SearchProjectPagesBody;params?: SearchProjectPagesParams}> = (props) => {
          const {organizationId,projectId,data,params} = props ?? {};

          return  searchProjectPages(organizationId,projectId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SearchProjectPagesMutationResult = NonNullable<Awaited<ReturnType<typeof searchProjectPages>>>
    export type SearchProjectPagesMutationBody = SearchProjectPagesBody
    export type SearchProjectPagesMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Search within a project's pages using keyword search
 */
export const useSearchProjectPages = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchProjectPages>>, TError,{organizationId: string;projectId: string;data: SearchProjectPagesBody;params?: SearchProjectPagesParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof searchProjectPages>>,
        TError,
        {organizationId: string;projectId: string;data: SearchProjectPagesBody;params?: SearchProjectPagesParams},
        TContext
      > => {
      return useMutation(getSearchProjectPagesMutationOptions(options), queryClient);
    }
    /**
 * Fetches all non-blank pages from the project's documents and queues each one to the RAG indexing SQS queue so sky-rag re-indexes them in pgVector. Pages are sent in batches with bounded concurrency to keep the response fast for large projects.
 * @summary Reindex a project's pages in pgVector (sky-rag)
 */
export const reindexProject = (
    organizationId: string,
    projectId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ReindexProject200>(
      {url: `/organizations/${organizationId}/projects/${projectId}/reindex`, method: 'POST', signal
    },
      options);
    }




export const getReindexProjectMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reindexProject>>, TError,{organizationId: string;projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reindexProject>>, TError,{organizationId: string;projectId: string}, TContext> => {

const mutationKey = ['reindexProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reindexProject>>, {organizationId: string;projectId: string}> = (props) => {
          const {organizationId,projectId} = props ?? {};

          return  reindexProject(organizationId,projectId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReindexProjectMutationResult = NonNullable<Awaited<ReturnType<typeof reindexProject>>>

    export type ReindexProjectMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Reindex a project's pages in pgVector (sky-rag)
 */
export const useReindexProject = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reindexProject>>, TError,{organizationId: string;projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reindexProject>>,
        TError,
        {organizationId: string;projectId: string},
        TContext
      > => {
      return useMutation(getReindexProjectMutationOptions(options), queryClient);
    }
    /**
 * Reads all document page content from S3 and indexes it in OpenSearch. Use this to fix search for documents that were processed before OpenSearch indexing was deployed.
 * @summary Reindex a project's pages in OpenSearch for keyword search
 */
export const reindexProjectSearch = (
    organizationId: string,
    projectId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ReindexProjectSearch200>(
      {url: `/organizations/${organizationId}/projects/${projectId}/search/reindex`, method: 'POST', signal
    },
      options);
    }




export const getReindexProjectSearchMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reindexProjectSearch>>, TError,{organizationId: string;projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reindexProjectSearch>>, TError,{organizationId: string;projectId: string}, TContext> => {

const mutationKey = ['reindexProjectSearch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reindexProjectSearch>>, {organizationId: string;projectId: string}> = (props) => {
          const {organizationId,projectId} = props ?? {};

          return  reindexProjectSearch(organizationId,projectId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReindexProjectSearchMutationResult = NonNullable<Awaited<ReturnType<typeof reindexProjectSearch>>>

    export type ReindexProjectSearchMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Reindex a project's pages in OpenSearch for keyword search
 */
export const useReindexProjectSearch = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reindexProjectSearch>>, TError,{organizationId: string;projectId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reindexProjectSearch>>,
        TError,
        {organizationId: string;projectId: string},
        TContext
      > => {
      return useMutation(getReindexProjectSearchMutationOptions(options), queryClient);
    }
    /**
 * Compatibility endpoint that returns the number of pages currently indexed in pgVector (sky-rag) for the project's case.
 * @summary Get the number of indexed pages for a project
 */
export const getProjectIndexedPages = (
    organizationId: string,
    projectId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetProjectIndexedPages200>(
      {url: `/organizations/${organizationId}/projects/${projectId}/indexed-pages`, method: 'GET', signal
    },
      options);
    }




export const getGetProjectIndexedPagesQueryKey = (organizationId: string,
    projectId: string,) => {
    return [
    `/organizations/${organizationId}/projects/${projectId}/indexed-pages`
    ] as const;
    }


export const getGetProjectIndexedPagesQueryOptions = <TData = Awaited<ReturnType<typeof getProjectIndexedPages>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectIndexedPages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProjectIndexedPagesQueryKey(organizationId,projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectIndexedPages>>> = ({ signal }) => getProjectIndexedPages(organizationId,projectId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined && projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProjectIndexedPages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectIndexedPagesQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectIndexedPages>>>
export type GetProjectIndexedPagesQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse


export function useGetProjectIndexedPages<TData = Awaited<ReturnType<typeof getProjectIndexedPages>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectIndexedPages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectIndexedPages>>,
          TError,
          Awaited<ReturnType<typeof getProjectIndexedPages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectIndexedPages<TData = Awaited<ReturnType<typeof getProjectIndexedPages>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectIndexedPages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectIndexedPages>>,
          TError,
          Awaited<ReturnType<typeof getProjectIndexedPages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectIndexedPages<TData = Awaited<ReturnType<typeof getProjectIndexedPages>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectIndexedPages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the number of indexed pages for a project
 */

export function useGetProjectIndexedPages<TData = Awaited<ReturnType<typeof getProjectIndexedPages>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectIndexedPages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProjectIndexedPagesQueryOptions(organizationId,projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






